module.exports = __webpack_public_path__ + "img/vcontroller-show-btn4-model.c5414e36.jpg";